<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <v-row no-gutters>
      <v-col v-if="!isCampaign" class="d-flex flex-column flex-md-row pa-2" cols="12">
        <div
          class="col-md-4 rounded p-5 mx-auto mb-4 mb-md-0" 
          style="background: rgba(193, 193, 193, 0.58)"
        >
          <p>پیام انتخاب شده:</p>
          <p
            v-if="message?.content"
            ref="previewMessage"
            class="font-size-lg"
            style="white-space: break-spaces; direction: rtl"
            v-html="previewText"
          ></p>
          <p v-else class="text-center grey--text pt-4">
            الگوی پیام انتخاب نشده
          </p>
        </div>

        <div
          class="col-md mr-1 rounded p-5"
          style="background: rgba(193, 193, 193, 0.58)"
        >
          <p>ورودی‌های اجباری:</p>
          <div v-for="key in patternKeys" :key="key" class="rowinfo mb-3">
            <v-text-field
              v-if="computedValue[key]?.state === 'data'"
              v-model="computedValue[key].text"
              :label="key"
              dense
              class="contentinfo"
            >
              <template v-slot:append-outer>
                <input-generate-menu v-model="computedValue[key].state" />
              </template>
            </v-text-field>

            <v-autocomplete
              v-else
              v-model="computedValue[key].text"
              :items="userInfoItems"
              :label="key"
              :readonly="readonly"
              dense
              class="contentinfo"
            >
              <template v-slot:append-outer>
                <input-generate-menu v-model="computedValue[key].state" />
              </template>
            </v-autocomplete>
          </div>
        </div>
      </v-col>

      <!-- حالت کمپین -->
      <v-col
        v-else-if="isCampaign && campaignMessages.length"
        class="pa-2"
        cols="12"
      >
        <v-card-title class="justify-center flex-wrap text-center">
          <div>
            <span class="grey--text font-size-h6">کمپین انتخاب شده:</span>
            <span class="primary--text px-2 text-h6">{{ campaignName }}</span>
          </div>
          <div class="grey--text mt-1">
            ({{ campaignMessages.length }} پیام)
          </div>
        </v-card-title>

        <div class="d-flex flex-wrap justify-center pa-4" style="gap: 20px">
          <div
            v-for="(text, i) in campaignMessages"
            :key="i"
            class="pa-5 rounded-lg grey lighten-2"
            style="min-width: 320px; max-width: 480px; position: relative"
          >
            <v-avatar
              class="mt-n12 ms-n7 white--text"
              color="success"
              size="36"
            >
              {{ i + 1 }}
            </v-avatar>
            <pre
              class="mt-4 mb-0 pa-3 rounded"
              style="
                white-space: pre-wrap;
                font-family: Vazir, sans-serif;
                direction: rtl;
                background: white;
                min-height: 80px;
              "
              >{{ text }}</pre
            >
            <div class="text-center mt-3">
              <small class="grey--text">
                {{ formatGap(campaignGaps[i], campaignTypes[i]) }}
              </small>
            </div>
          </div>
        </div>
      </v-col>

      <v-col v-else-if="isCampaign" class="pa-12 text-center">
        <v-icon x-large color="grey lighten-1">mdi-message-bulleted-off</v-icon>
        <p class="mt-6 grey--text text-h6">این کمپین پیام فعالی ندارد</p>
      </v-col>
    </v-row>
  </help-info-wrapper>
</template>

<script>
import InputGenerateMenu from "@/view/components/fragments/inputGenerateMenu.vue";
import HelpInfoWrapper from "../../pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";

export default {
  name: "patternInputsGenerateDigi",
  components: { InputGenerateMenu, HelpInfoWrapper },

  props: {
    value: { type: Object, default: () => ({}) },
    isCampaign: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    message: {
      type: Object,
      default: () => ({
        content: "",
        messages: { name: "", text: [], gap: [], type: [], count: 0 },
      }),
    },
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "patterninputsGenerate",
    userInfoItems: [
      { value: "name", text: "نام" },
      { value: "postal_code", text: "کدپستی" },
      { value: "state", text: "استان" },
      { value: "city", text: "شهر" },
      { value: "address", text: "آدرس" },
      { value: "phone", text: "شماره تلفن" }, 
      {value:"discount",text:"کد تخفیف"},     
    ],
  }),

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    previewText() {
      if (!this.message?.content) return "";
      let text = this.message.content;
      this.patternKeys.forEach((key) => {
        text = text.replace(new RegExp(`\\b${key}\\b`, "g"), key);
      });
      return text;
    },
    // previewText() {
    //   if (!this.message?.content) return "";
    //   let text = this.message.content;
    //   this.patternKeys.forEach((key) => {
    //     const val = this.computedValue[key];
    //     if (val?.state === "data") {
    //       text = text.replace(new RegExp(key, "g"), val.text || key);
    //     } else {
    //       text = text.replace(new RegExp(key, "g"), `{${val?.text || key}}`);
    //     }
    //   });
    //   return text;
    // },
    campaignName() {
      return (
        this.value?.name || this.message?.messages?.name || "کمپین بدون نام"
      );
    },
    campaignMessages() {
      return this.value?.text || this.message?.messages?.text || [];
    },
    campaignGaps() {
      return this.value?.gap || this.message?.messages?.gap || [];
    },
    campaignTypes() {
      return this.value?.type || this.message?.messages?.type || [];
    },
    patternContent() {
      return this.isCampaign ? "" : this.message?.content || "";
    },

    patternKeys() {
      if (this.isCampaign) return [];

      let content = this.message?.content || "";

      if (!content && this.value && Object.keys(this.value).length > 0) {
        const keys = Object.keys(this.value).filter((k) => /^data\d+$/.test(k));
        if (keys.length > 0) {
          content = keys.join(" ");
        }
      }

      const matches = content.match(/data\d+/g) || [];
      return [...new Set(matches)];
    },
  },

  methods: {
    formatGap(gap, type = "hour") {
      if (gap === 0 || gap === "0") return "ارسال فوری";
      const num = parseInt(gap);
      if (isNaN(num)) return "";
      return `${num} ${type === "hour" ? "ساعت" : "روز"} بعد`;
    },
    ensurePatternFields() {
      if (this.isCampaign) return;

      const currentKeys = this.patternKeys;
      const newValue = { ...this.value };
      currentKeys.forEach((key) => {
        if (!newValue.hasOwnProperty(key)) {
          this.$set(newValue, key, {
            state: "userInfo",
            text: "name",
          });
        }
      });
      Object.keys(newValue).forEach((key) => {
        if (!currentKeys.includes(key) && /^data\d+$/.test(key)) {
          this.$delete(newValue, key);
        }
      });

      if (JSON.stringify(newValue) !== JSON.stringify(this.value)) {
        this.computedValue = newValue;
      }
    },
  },

  watch: {
    patternKeys: {
      immediate: true,
      handler() {
        this.$nextTick(() => this.ensurePatternFields());
      },
    },
    value: {
      deep: true,
      handler(newVal) {
        if (!this.isCampaign && newVal) {
          this.$nextTick(() => this.ensurePatternFields());
        }
      },
    },
  },

  mounted() {
    this.ensurePatternFields();
  },
};
</script>

<style scoped>
pre {
  font-family: "Vazir", sans-serif !important;
}
</style>
